export const notificationActions = {

  FETCH_NOTIFICATION_FAILED: 'FETCH_NOTIFICATION_FAILED',
  FETCH_NOTIFICATION_SUCCESS: 'FETCH_NOTIFICATION_SUCCESS',
  FETCH_NOTIFICATION_PENDING: 'FETCH_NOTIFICATION_PENDING',
  LOAD_NOTIFICATION: 'LOAD_NOTIFICATION',


  fetchNotificationFailed: error => ({
    type: notificationActions.FETCH_NOTIFICATION_FAILED,
    payload: error
  }),

  fetchNotificationSuccess: (notificationId, {data}) => ({
    type: notificationActions.FETCH_NOTIFICATION_SUCCESS,
    payload: {
      notification: data.item,
      notificationId: notificationId
    }
  }),

  fetchNotificationPending: notificationId => ({
    type: notificationActions.FETCH_NOTIFICATION_PENDING,
    payload: {
      notificationId
    }
  }),

  loadNotification: (notificationId, sessionId) => ({
    type: notificationActions.LOAD_NOTIFICATION,
    payload: {
      notificationId,
      sessionId
    }
  }),

};


export const notificationRequestActions = {
  failed: notificationActions.fetchNotificationFailed,
  success: notificationActions.fetchNotificationSuccess,
  pending: notificationActions.fetchNotificationPending
};
